import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=480a7c4c&scoped=true&"
var script = {}
import style0 from "./Welcome.vue?vue&type=style&index=0&id=480a7c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480a7c4c",
  null
  
)

export default component.exports